import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import ProductFilterBlock from "../../../ProductFilters/ProductFilterBlock";
import CategoryFilterBlock from "../../../ProductFilters/CategoryFilterBlock";
import { Button } from "arv-reactcomponents";

@inject("ProductStore")
@observer
class RefineView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryFiltersOpen: false,
    };
    this.onFilterClick = this.onFilterClick.bind(this);
    this.getActiveClass = this.getActiveClass.bind(this);
    this.currentCategoryFilterState = this.currentCategoryFilterState.bind(
      this,
    );
  }
  onFilterClick(event) {
    event.preventDefault();
    const flag = this.state.categoryFiltersOpen;
    this.setState({
      categoryFiltersOpen: !flag,
    });
  }
  getActiveClass(articleType) {
    this.toggle = articleType;
    return this.state.categoryFiltersOpen ? "nw-filteropen" : "";
  }
  currentCategoryFilterState() {
    return this.state.categoryFiltersOpen;
  }
  render() {
    const { callCount } = this.props.ProductStore;
    console.log(callCount);
    const count =
      this.props.ProductStore.ProductData.filters.articleType.selectedCount > 0
        ? `(${
            this.props.ProductStore.ProductData.filters.articleType
              .selectedCount
          })`
        : "";
    const filters =
      this.props.ProductStore.tempFilters ||
      this.props.ProductStore.ProductData.filters;
    return (
      <div className="nw-mobilefilters-refineviewcontainer">
        <h1 className="nw-mobilefilters-filterheadings">Filter By:</h1>
        <Button
          onClick={event => this.onFilterClick(event)}
          className={`nwc-btn-secondary nw-productfilterblock-filterbutton nw-mobilefilters-refineview nw-mobilefilters-category  ${this.getActiveClass(
            filters.articleType,
          )}`}
        >
          <i
            className={`icomoon-arrow_right nw-productfilterblock-rightarrow ${this.getActiveClass(
              filters.articleType,
            )}`}
          />
          <span>{filters.articleType.displayName}</span>
          <span className="nw-mobilefilters-refineviewcategoryselectedcount">
            {count}
          </span>
        </Button>
        {this.currentCategoryFilterState() && (
          <CategoryFilterBlock.component
            categoryfilters={filters.articleType}
            newArrivalsfilters={filters.newArrivals}
            onSalefilters={filters.onSale}
            className="nw-mobilefilters-refineview"
          />
        )}

        <ProductFilterBlock.component
          filterBy={filters.filterBy}
          className="nw-mobilefilters-refineview"
        />
      </div>
    );
  }
}

RefineView.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    callCount: PropTypes.number.isRequired,
    tempFilters: PropTypes.shape(),
    ProductData: PropTypes.shape({
      filters: PropTypes.shape({
        newArrivals: PropTypes.shape({}).isRequired,
        onSale: PropTypes.shape({}).isRequired,
        filterBy: PropTypes.shape([]).isRequired,
        articleType: PropTypes.shape({
          displayName: PropTypes.string.isRequired,
          isFilterOpen: PropTypes.bool,
          selectedCount: PropTypes.number.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: RefineView.wrappedComponent,
  component: RefineView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MobileFilters/FilterViews/RefineView/index.js